import { z } from 'zod';

export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
});

export type ApiErrorSchema = z.infer<typeof apiErrorSchema>;

export const apiSuccessSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    ok: z.literal(true),
    data: dataSchema,
  });

export const apiFailSchema = z.object({
  ok: z.literal(false),
  error: apiErrorSchema,
});

export const apiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.discriminatedUnion('ok', [apiSuccessSchema(dataSchema), apiFailSchema]);

export type ApiSuccessResponse<T> = { ok: true; data: T };
export type ApiFailResponse = z.infer<typeof apiFailSchema>;
export type ApiSchemaResponse<T> = ApiSuccessResponse<T> | ApiFailResponse;
